import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ForceHomeOnRefresh from "./ForceHomeOnRefresh";
import Home from "./Home";
import LiderErp from "./LiderErp";
import Lider from "./Lider";
import Newsletter from "./NewsLetter.jsx";
import Careers from "./Careers";
import Login from "./Login";
import AdminDashboard from "./AdminDashboard.jsx";

import Lidererp from "./Products/lider_erp.jsx";
import LiderConnect from "./Products/lider-connect";
import Circuit from "./Products/circuit";
import Pathway from "./Products/pathway";
import Impulz from "./Products/impulz";
import MissedCallAlert from "./Products/missed-call-alert";
import ICleverGate from "./Products/iclever-gate";
import ThedalDictionary from "./Products/thedal-dictionary";
import Kiosk from "./Products/kiosk";
import WebsiteDevelopment from "./Services/WebsiteDevelopment.jsx";
import AppDevelopment from "./Services/AppDevelopment";
import SoftwareTesting from "./Services/SoftwareTesting";
import ManualTesting from "./Services/ManualTesting.jsx";
import SoftwareAutomationTesting from "./Services/AutomationTesting.jsx";
import CloudDataAnalytics from "./Services/CloudAndDataAnalytics.jsx";
import ResearchAndDevelopment from "./Services/ResearchAndDevelopment";
import ForgotPassword from "./ForgotPassword";
import ResetPassword  from "./ResetPassword";
import Clients from "./Clients.jsx";
import BowerCred from "./Products/BowerCred.jsx";
import ImpulzKids from "./Products/ImpulzKids.jsx";
import SchoolLMS from "./Products/SchoolLMS.jsx";
import CollegesPage from "./Products/CollegesPage.jsx";
import AEGCollegePage from "./Products/AEGCollegePage.jsx";
import AlliansCollegePage from "./Products/AlliansCollegePage.jsx";
import NewtonCollegePage from "./Products/NewtonCollegePage.jsx";
import TrentCollegePage from "./Products/TrentCollegePage.jsx";
import JurongCollegePage from "./Products/JurongCollegePage.jsx";
import JEENEETSmartLearningPage from "./Products/JEENEETSmartLearningPage.jsx";
import NewTNPSCSmartAIPage from "./Products/NewTNPSCSmartAIPage.jsx";


const PrivateRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  if (!token) return <Navigate to="/login" replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/" replace />;
  return children;
};

function App() {

  return (
    <Router>
      <ForceHomeOnRefresh />
      <Routes>

        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<LiderErp />} />
        <Route path="/about-us/lider" element={<Lider />} />
        <Route path="/Newsletter" element={<Newsletter />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/login" element={<Login />} />


        <Route path="/products/lider-erp" element={<Lidererp />} />
        <Route path="/products/lider-connect" element={<LiderConnect />} />
        <Route path="/products/impulz" element={<Impulz />} />
        <Route path="/products/thedal-dictionary" element={<ThedalDictionary />} />
        <Route path="/products/missed-call-alert" element={<MissedCallAlert />} />
        <Route path="/products/circuit" element={<Circuit />} />
        <Route path="/products/pathway" element={<Pathway />} />





        <Route path="/products/bower-cred" element={<BowerCred />} />
        <Route
    path="/products/impulz/kids"
    element={<ImpulzKids />}
/>
        <Route path="/products/impulz/school-lms" element={<SchoolLMS />} />
        <Route path="/products/impulz/college-lms" element={<CollegesPage />} />
<Route path="/colleges/aeg" element={<AEGCollegePage />} />
<Route path="/colleges/allians" element={<AlliansCollegePage />} />
                <Route path="/colleges/newton" element={<NewtonCollegePage />} />  
                <Route path="/colleges/trent" element={<TrentCollegePage />} />   
                <Route path="/colleges/jurong" element={<JurongCollegePage />} />  
                <Route path="/products/impulz/jee-neet" element={<JEENEETSmartLearningPage />} />  
                <Route path="/products/impulz/tnpsc" element={<NewTNPSCSmartAIPage />} />   




        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password"  element={<ResetPassword />} />
          <Route path="/admin/dashboard" element={
          <PrivateRoute allowedRoles={["ADMIN", "MANAGER"]}>
            <AdminDashboard />
          </PrivateRoute>
        } />


                   <Route
                    path="/client"
                    element={<Clients />}
                   />




       
        <Route path="/products/iclever-gate" element={<ICleverGate />} />

        <Route path="/products/kiosk" element={<Kiosk />} />

        <Route path="/services/website-development" element={<WebsiteDevelopment />} />
        <Route path="/services/app-development" element={<AppDevelopment />} />
        <Route path="/services/software-testing" element={<SoftwareTesting />} />
        <Route path="/services/manual-testing" element={<ManualTesting />} />
        <Route
          path="/services/software-automation-testing"
          element={<SoftwareAutomationTesting />}
        />
        <Route
          path="/services/cloud-data-analytics"
          element={<CloudDataAnalytics />}
        />
        <Route
          path="/services/research-and-development"
          element={<ResearchAndDevelopment />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
